function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9393 54.394C11.5251 54.9798 12.4749 54.9798 13.0607 54.394L22.6066 44.848C23.1924 44.2623 23.1924 43.3125 22.6066 42.7267C22.0208 42.1409 21.0711 42.1409 20.4853 42.7267L12 51.212L3.51472 42.7267C2.92893 42.1409 1.97918 42.1409 1.3934 42.7267C0.807609 43.3125 0.807609 44.2623 1.3934 44.848L10.9393 54.394ZM10.5 -7.29434e-08L10.5 53.3333L13.5 53.3333L13.5 7.29434e-08L10.5 -7.29434e-08Z",
  fill: "#fff"
});

function SvgArrow2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 55,
    viewBox: "0 0 24 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "scroll",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/Arrow 2.40025ef2.svg";
export { ForwardRef as ReactComponent };